import { render, staticRenderFns } from "./CpView.vue?vue&type=template&id=c675cdf4"
import script from "./CpView.vue?vue&type=script&lang=js"
export * from "./CpView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports